interface SectionHeaderProps {
  tag: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeader({ tag, title, desc, align = "center" }: SectionHeaderProps) {
  return (
    <div className={`mb-8 md:mb-12 ${align === "center" ? "text-center" : "text-left"}`}>
      <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
        <i className="ri-sparkling-2-line text-sm"></i>
        {tag}
      </span>
      <h2 className={`font-heading mt-3 text-2xl md:text-4xl font-bold text-foreground-950 ${align === "center" ? "mx-auto" : ""}`}>
        {title}
      </h2>
      {desc && (
        <p className={`mt-3 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600 ${align === "center" ? "mx-auto" : ""}`}>
          {desc}
        </p>
      )}
    </div>
  );
}